var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtifacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#5B61F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1666 75H68.1666C70.1558 75 72.0634 74.2098 73.4699 72.8033C74.8764 71.3968 75.6666 69.4891 75.6666 67.5V42.5C75.6666 40.5109 74.8764 38.6032 73.4699 37.1967C72.0634 35.7902 70.1558 35 68.1666 35H63.1666V30C63.1666 28.6739 62.6398 27.4021 61.7022 26.4645C60.7645 25.5268 59.4927 25 58.1666 25H43.1666C41.8405 25 40.5688 25.5268 39.6311 26.4645C38.6934 27.4021 38.1666 28.6739 38.1666 30V35H33.1666C31.1775 35 29.2698 35.7902 27.8633 37.1967C26.4568 38.6032 25.6666 40.5109 25.6666 42.5V67.5C25.6666 69.4891 26.4568 71.3968 27.8633 72.8033C29.2698 74.2098 31.1775 75 33.1666 75ZM43.1666 30H58.1666V35H43.1666V30ZM30.6666 42.5C30.6666 41.837 30.93 41.2011 31.3989 40.7322C31.8677 40.2634 32.5036 40 33.1666 40H68.1666C68.8297 40 69.4656 40.2634 69.9344 40.7322C70.4032 41.2011 70.6666 41.837 70.6666 42.5V45.875L50.6666 54.765L30.6666 45.875V42.5ZM30.6666 51.3475L49.6516 59.785C49.9712 59.927 50.317 60.0003 50.6666 60.0003C51.0163 60.0003 51.3621 59.927 51.6816 59.785L70.6666 51.3475V67.5C70.6666 68.163 70.4032 68.7989 69.9344 69.2678C69.4656 69.7366 68.8297 70 68.1666 70H33.1666C32.5036 70 31.8677 69.7366 31.3989 69.2678C30.93 68.7989 30.6666 68.163 30.6666 67.5V51.3475Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtifacts);
export default __webpack_public_path__ + "static/media/artifacts.f596649f6a1e291822ca444b579edee8.svg";
export { ForwardRef as ReactComponent };